import React, { useState } from "react";

export const GdprList = () => {
  const [activeSubTab, setActiveSubTab] = useState<"gdpr" | "dpia">("gdpr");

  // Τα paths αντιστοιχούν ακριβώς στη δομή που φαίνεται στην εικόνα σου (public/docs/)
  const gdprPdfPath = "/docs/GPDR_Regulation.pdf";
  const dpiaWordPath = "/docs/DPIA.docx";

  return (
    <div className="space-y-6">
      {/* Sub-tabs επιλογής ανάμεσα σε GDPR και DPIA */}
      <div className="flex border-b border-gray-200">
        <button
          onClick={() => setActiveSubTab("gdpr")}
          className={`pb-3 px-4 font-medium text-sm transition-colors border-b-2 ${
            activeSubTab === "gdpr"
              ? "border-primary text-primary"
              : "border-transparent text-gray-500 hover:text-gray-700"
          }`}
        >
          📜 Κανονισμός GDPR (PDF)
        </button>
        <button
          onClick={() => setActiveSubTab("dpia")}
          className={`pb-3 px-4 font-medium text-sm transition-colors border-b-2 ${
            activeSubTab === "dpia"
              ? "border-primary text-primary"
              : "border-transparent text-gray-500 hover:text-gray-700"
          }`}
        >
          📊 Αρχείο DPIA (Word)
        </button>
      </div>

      {/* Περιεχόμενο καρτέλας */}
      <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">
          {activeSubTab === "gdpr" ? "Κανονισμός Προστασίας Δεδομένων (GDPR)" : "Εκτίμηση Αντικτύπου (DPIA)"}
        </h3>
        
        <p className="text-sm text-gray-600 mb-6">
          {activeSubTab === "gdpr" 
            ? "Μπορείτε να διαβάσετε τον επίσημο κανονισμό απευθείας στον browser ή να τον κατεβάσετε στη συσκευή σας."
            : "Το επίσημο αρχείο εκτίμησης αντικτύπου (DPIA) της εφαρμογής σε μορφή Word."
          }
        </p>

        {/* Κουμπιά ενέργειας */}
        <div className="flex flex-wrap gap-4">
          {activeSubTab === "gdpr" ? (
            <>
              <a
                href={gdprPdfPath}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 bg-white text-primary border border-primary text-sm font-medium rounded-lg hover:bg-primary hover:text-white transition flex items-center gap-2 shadow-sm"
              >
                👁️ Προβολή PDF
              </a>
              <a
                href={gdprPdfPath}
                download="GPDR_Regulation.pdf"
                className="px-4 py-2 bg-primary text-white text-sm font-medium rounded-lg hover:bg-darkprimary transition flex items-center gap-2 shadow-sm"
              >
                📥 Λήψη PDF
              </a>
            </>
          ) : (
            <a
              href={dpiaWordPath}
              download="DPIA.docx"
              className="px-4 py-2 bg-primary text-white text-sm font-medium rounded-lg hover:bg-darkprimary transition flex items-center gap-2 shadow-sm"
            >
              📥 Λήψη Αρχείου Word (DPIA)
            </a>
          )}
        </div>
      </div>
    </div>
  );
};